export default "__VITE_ASSET__CjzYtNR8__"